import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import {withStyles} from '@material-ui/core/styles';
import { lightGreen } from '@material-ui/core/colors';

  const CustomCheckbox = withStyles({
    root: {
     color: lightGreen[400],
     '&$checked': {
       color: lightGreen[600],
     },
    },
    checked: {},
  })(props => <Checkbox color="default" {...props} />);

export {CustomCheckbox};
